import '../../../common/dashboard/filters/filter.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.GroupsFilter extends Common.Dashboard.Filters.Filter

  @FILTER_TYPE: 'intelligent_groups'
  removable: true

  getFilterType: ->
    CustomerVisualMode.Filters.GroupsFilter.FILTER_TYPE

  hasValues: ->
    !!@values

  _valuesToJSON: ->
    @values

  removeValue: (valueToRemove) ->
    @values = valueToRemove
